export default "__VITE_ASSET__e867cf3c__"